import { render, staticRenderFns } from "./PostCreateHistory.vue?vue&type=template&id=0b418a4c"
import script from "./PostCreateHistory.vue?vue&type=script&lang=js"
export * from "./PostCreateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports